import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateTwoD=(id,status,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_TWOD_START
    })
    const options={
        url:`${api}/twoDNumbers/${id}`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{status}
    }
    await axios(options)
                .then(response=>dispatch({
                    type:actionTypes.UPDATE_TWOD_SUCCESS,
                    payload:response.data
                }))
                .catch(error=>dispatch({
                    type:actionTypes.UPDATE_TWOD_FAIL,
                    payload:getMessage(error)
                }))
}